// History.js
import { createBrowserHistory, createMemoryHistory } from "history"

const { NODE_ENV } = process.env
const inTesting = NODE_ENV === "test"

const history = inTesting ? createMemoryHistory({ initialEntries: ["/"] }) : createBrowserHistory()

export default history
